<script lang="ts">
    import { originURL } from "../../../../api/hooks/config-client"
    import { getCachedEntry } from "../../api"
    import NotFound from "../../routes/NotFound.svelte"
    import Breadcrumbs from "./Breadcrumbs.svelte"
    import ContentBlock from "./ContentBlock.svelte"

    export let location: LocationStore = undefined
    export let id: string = undefined
    export let allwaysInView: boolean = false
    export let previewContent: ContentEntry<"page"> = undefined

    let loading = true
    let contentEntry: ContentEntry<"page">
    async function loadContent() {
        loading = true
        contentEntry = null
        try {
            contentEntry = (await getCachedEntry(
                "content",
                location ? { $or: [{ path: location.path }] } : { _id: id }
            )) as ContentEntry<"page">
        } catch (e) {
            console.error(e)
        }
        loading = false
    }

    // only load new content if location.path or id changes
    let _location: typeof location
    let _id: typeof id
    $: if (previewContent) {
        contentEntry = previewContent
        loading = false
    } else if (location?.path != _location?.path || id != _id || location?.hash !== _location?.hash) {
        _id = id
        _location = location
        loadContent()
    }
</script>

<svelte:head>
    {#if contentEntry}
        {#if contentEntry.meta?.title || contentEntry.name}
            <title>Rechtec - {contentEntry.meta?.title || contentEntry.name}</title>
        {/if}
        {#if contentEntry.meta?.description}
            <meta name="description" content="{contentEntry.meta.description}" />
        {/if}
        {#if contentEntry.meta?.keywords}
            <meta name="keywords" content="{contentEntry.meta.keywords}" />
        {/if}
        {#if contentEntry.meta?.date}
            <meta name="date" content="{String(contentEntry.meta.date)}" />
        {/if}
        <!-- if not active do not index -->
        {#if !contentEntry.active}
            <meta name="robots" content="noindex" />
        {/if}

        {#if contentEntry.path && location?.path != contentEntry.path}
            <link rel="canonical" href="{originURL}{contentEntry.path}" />
        {/if}
    {/if}
</svelte:head>

{#if loading}
    .... lade
{:else if contentEntry}
    <Breadcrumbs {location} name="{contentEntry.name}" />

    {#each contentEntry.blocks as block}
        <ContentBlock {block} />
    {/each}
{:else}
    <NotFound />
{/if}
